module.exports = __webpack_public_path__ + "img/IMG-20200809-WA0012.6aef3d85.jpg";